/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GlobalStatsDto } from '../models/global-stats-dto';
import { PaginatedJobsDto } from '../models/paginated-jobs-dto';
import { PaginatedUsersDto } from '../models/paginated-users-dto';
import { ProcessingJobModelDto } from '../models/processing-job-model-dto';
import { ProcessingWorkerModelDto } from '../models/processing-worker-model-dto';
import { SessionDto } from '../models/session-dto';
import { superadminControllerDeleteWorker } from '../fn/superadmin/superadmin-controller-delete-worker';
import { SuperadminControllerDeleteWorker$Params } from '../fn/superadmin/superadmin-controller-delete-worker';
import { superadminControllerGetGlobalStats } from '../fn/superadmin/superadmin-controller-get-global-stats';
import { SuperadminControllerGetGlobalStats$Params } from '../fn/superadmin/superadmin-controller-get-global-stats';
import { superadminControllerGetUser } from '../fn/superadmin/superadmin-controller-get-user';
import { SuperadminControllerGetUser$Params } from '../fn/superadmin/superadmin-controller-get-user';
import { superadminControllerGetUserStats } from '../fn/superadmin/superadmin-controller-get-user-stats';
import { SuperadminControllerGetUserStats$Params } from '../fn/superadmin/superadmin-controller-get-user-stats';
import { superadminControllerImpersonate } from '../fn/superadmin/superadmin-controller-impersonate';
import { SuperadminControllerImpersonate$Params } from '../fn/superadmin/superadmin-controller-impersonate';
import { superadminControllerListJobs } from '../fn/superadmin/superadmin-controller-list-jobs';
import { SuperadminControllerListJobs$Params } from '../fn/superadmin/superadmin-controller-list-jobs';
import { superadminControllerListTags } from '../fn/superadmin/superadmin-controller-list-tags';
import { SuperadminControllerListTags$Params } from '../fn/superadmin/superadmin-controller-list-tags';
import { superadminControllerListUsers } from '../fn/superadmin/superadmin-controller-list-users';
import { SuperadminControllerListUsers$Params } from '../fn/superadmin/superadmin-controller-list-users';
import { superadminControllerListWorkers } from '../fn/superadmin/superadmin-controller-list-workers';
import { SuperadminControllerListWorkers$Params } from '../fn/superadmin/superadmin-controller-list-workers';
import { superadminControllerRequeueJob } from '../fn/superadmin/superadmin-controller-requeue-job';
import { SuperadminControllerRequeueJob$Params } from '../fn/superadmin/superadmin-controller-requeue-job';
import { superadminControllerUpdateSubscription } from '../fn/superadmin/superadmin-controller-update-subscription';
import { SuperadminControllerUpdateSubscription$Params } from '../fn/superadmin/superadmin-controller-update-subscription';
import { superadminControllerUpdateTags } from '../fn/superadmin/superadmin-controller-update-tags';
import { SuperadminControllerUpdateTags$Params } from '../fn/superadmin/superadmin-controller-update-tags';
import { SuperadminUserDto } from '../models/superadmin-user-dto';
import { UserStatsDto } from '../models/user-stats-dto';

@Injectable({ providedIn: 'root' })
export class SuperadminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `superadminControllerListWorkers()` */
  static readonly SuperadminControllerListWorkersPath = '/superadmin/workers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerListWorkers()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListWorkers$Response(params?: SuperadminControllerListWorkers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProcessingWorkerModelDto>>> {
    return superadminControllerListWorkers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerListWorkers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListWorkers(params?: SuperadminControllerListWorkers$Params, context?: HttpContext): Observable<Array<ProcessingWorkerModelDto>> {
    return this.superadminControllerListWorkers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProcessingWorkerModelDto>>): Array<ProcessingWorkerModelDto> => r.body)
    );
  }

  /** Path part for operation `superadminControllerDeleteWorker()` */
  static readonly SuperadminControllerDeleteWorkerPath = '/superadmin/workers/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerDeleteWorker()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerDeleteWorker$Response(params: SuperadminControllerDeleteWorker$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return superadminControllerDeleteWorker(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerDeleteWorker$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerDeleteWorker(params: SuperadminControllerDeleteWorker$Params, context?: HttpContext): Observable<void> {
    return this.superadminControllerDeleteWorker$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `superadminControllerListJobs()` */
  static readonly SuperadminControllerListJobsPath = '/superadmin/jobs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerListJobs()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListJobs$Response(params?: SuperadminControllerListJobs$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedJobsDto>> {
    return superadminControllerListJobs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerListJobs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListJobs(params?: SuperadminControllerListJobs$Params, context?: HttpContext): Observable<PaginatedJobsDto> {
    return this.superadminControllerListJobs$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedJobsDto>): PaginatedJobsDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerRequeueJob()` */
  static readonly SuperadminControllerRequeueJobPath = '/superadmin/jobs/{uuid}/requeue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerRequeueJob()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerRequeueJob$Response(params: SuperadminControllerRequeueJob$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessingJobModelDto>> {
    return superadminControllerRequeueJob(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerRequeueJob$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerRequeueJob(params: SuperadminControllerRequeueJob$Params, context?: HttpContext): Observable<ProcessingJobModelDto> {
    return this.superadminControllerRequeueJob$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProcessingJobModelDto>): ProcessingJobModelDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetGlobalStats()` */
  static readonly SuperadminControllerGetGlobalStatsPath = '/superadmin/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetGlobalStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetGlobalStats$Response(params?: SuperadminControllerGetGlobalStats$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalStatsDto>> {
    return superadminControllerGetGlobalStats(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetGlobalStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetGlobalStats(params?: SuperadminControllerGetGlobalStats$Params, context?: HttpContext): Observable<GlobalStatsDto> {
    return this.superadminControllerGetGlobalStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<GlobalStatsDto>): GlobalStatsDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerListUsers()` */
  static readonly SuperadminControllerListUsersPath = '/superadmin/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerListUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListUsers$Response(params?: SuperadminControllerListUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedUsersDto>> {
    return superadminControllerListUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerListUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListUsers(params?: SuperadminControllerListUsers$Params, context?: HttpContext): Observable<PaginatedUsersDto> {
    return this.superadminControllerListUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedUsersDto>): PaginatedUsersDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerListTags()` */
  static readonly SuperadminControllerListTagsPath = '/superadmin/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerListTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListTags$Response(params?: SuperadminControllerListTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return superadminControllerListTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerListTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListTags(params?: SuperadminControllerListTags$Params, context?: HttpContext): Observable<Array<string>> {
    return this.superadminControllerListTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetUser()` */
  static readonly SuperadminControllerGetUserPath = '/superadmin/users/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUser$Response(params: SuperadminControllerGetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminUserDto>> {
    return superadminControllerGetUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUser(params: SuperadminControllerGetUser$Params, context?: HttpContext): Observable<SuperadminUserDto> {
    return this.superadminControllerGetUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<SuperadminUserDto>): SuperadminUserDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetUserStats()` */
  static readonly SuperadminControllerGetUserStatsPath = '/superadmin/users/{uuid}/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetUserStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUserStats$Response(params: SuperadminControllerGetUserStats$Params, context?: HttpContext): Observable<StrictHttpResponse<UserStatsDto>> {
    return superadminControllerGetUserStats(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetUserStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUserStats(params: SuperadminControllerGetUserStats$Params, context?: HttpContext): Observable<UserStatsDto> {
    return this.superadminControllerGetUserStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserStatsDto>): UserStatsDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerUpdateTags()` */
  static readonly SuperadminControllerUpdateTagsPath = '/superadmin/users/{uuid}/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerUpdateTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpdateTags$Response(params: SuperadminControllerUpdateTags$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminUserDto>> {
    return superadminControllerUpdateTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerUpdateTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpdateTags(params: SuperadminControllerUpdateTags$Params, context?: HttpContext): Observable<SuperadminUserDto> {
    return this.superadminControllerUpdateTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<SuperadminUserDto>): SuperadminUserDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerUpdateSubscription()` */
  static readonly SuperadminControllerUpdateSubscriptionPath = '/superadmin/users/{uuid}/subscription';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerUpdateSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpdateSubscription$Response(params: SuperadminControllerUpdateSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminUserDto>> {
    return superadminControllerUpdateSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerUpdateSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpdateSubscription(params: SuperadminControllerUpdateSubscription$Params, context?: HttpContext): Observable<SuperadminUserDto> {
    return this.superadminControllerUpdateSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SuperadminUserDto>): SuperadminUserDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerImpersonate()` */
  static readonly SuperadminControllerImpersonatePath = '/superadmin/users/{uuid}/impersonate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerImpersonate()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerImpersonate$Response(params: SuperadminControllerImpersonate$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionDto>> {
    return superadminControllerImpersonate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerImpersonate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerImpersonate(params: SuperadminControllerImpersonate$Params, context?: HttpContext): Observable<SessionDto> {
    return this.superadminControllerImpersonate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SessionDto>): SessionDto => r.body)
    );
  }

}
